import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const tomos = [{
  emoji: '📘',
  color: 'from-blue-500 to-cyan-500',
  title: 'Tomo I — Protocolo de Diagnóstico Inicial',
  subtitle: 'Identificá cualquier falla en minutos con un sistema claro de inspección y diagnóstico.',
  items: ['Diagnóstico de ruidos por tipo y ubicación', 'Inspección visual estructurada en 7 puntos', 'Identificación de fallas mecánicas y eléctricas', 'Registro de síntomas y soluciones aplicadas', 'Plantilla de evaluación pre-reparación']
}, {
  emoji: '📗',
  color: 'from-green-500 to-emerald-500',
  title: 'Tomo II — Mantenimiento Preventivo',
  subtitle: 'Plan completo de mantenimiento para que tu scooter dure años en perfecto estado.',
  items: ['Cronograma de mantenimiento mensual y anual', 'Checklist de inspección semanal', 'Ajuste de tornillos críticos y puntos de tensión', 'Lubricación de rodamientos y partes móviles', 'Cuidado de neumáticos, frenos y suspensión']
}, {
  emoji: '📕',
  color: 'from-red-500 to-pink-500',
  title: 'Tomo III — Manual de Reparación Express',
  subtitle: 'Reparaciones reales paso a paso para resolver fallas en 30 minutos o menos.',
  items: ['Reparación del sistema de plegado', 'Cambio de neumáticos y cámaras', 'Ajuste de frenos disco y tambor', 'Reemplazo de manubrios y acelerador', 'Soluciones express para vibraciones y juegos']
}, {
  emoji: '📙',
  color: 'from-yellow-500 to-orange-500',
  title: 'Tomo IV — Sistema Eléctrico y Batería Pro',
  subtitle: 'Dominio total del corazón eléctrico de tu scooter.',
  items: ['Diagnóstico de fallas eléctricas comunes', 'Mantenimiento y calibrado de batería', 'Reemplazo de controladores y displays', 'Diagrama de conexiones y mazo eléctrico', 'Protocolo de carga óptima para alargar vida útil']
}, {
  emoji: '📓',
  color: 'from-purple-500 to-violet-500',
  title: 'Tomo V — Guía de Emergencias en Ruta',
  subtitle: 'Resolución de problemas críticos cuando estás lejos del taller.',
  items: ['Protocolo de fallas en ruta paso a paso', 'Kit mínimo de herramientas para llevar siempre', 'Reparaciones de emergencia sin repuestos', 'Manejo seguro ante fallas de frenado o motor', 'Decisiones críticas: rodar o no rodar']
}, {
  emoji: '📔',
  color: 'from-indigo-500 to-blue-500',
  title: 'Tomo VI — Negocio del Scooter: Monetización',
  subtitle: 'Convertí tu conocimiento en una fuente real de ingresos.',
  items: ['Cómo iniciar un taller de scooters desde cero', 'Tarifario sugerido por tipo de servicio', 'Plantilla de presupuesto y orden de trabajo', 'Estrategia de captación de clientes en redes', 'Protocolo de atención y fidelización']
}];
export function TomosSection() {
  return <section className="py-12 md:py-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-139">
      <h2 className="text-3xl md:text-5xl font-bold text-center mb-4 md:mb-6" data-id="element-140">
        ¿Qué incluye el <span className="text-[#ff2e92]" data-id="element-141">Mega Kit Scooter</span>
        ?
      </h2>
      <p className="text-base md:text-xl text-zinc-400 text-center mb-10 md:mb-16 max-w-4xl mx-auto" data-id="element-142">
        Un sistema completo de recursos profesionales listos para usar. Incluye
        6 tomos con plantillas, protocolos y herramientas técnicas que podés
        aplicar directamente desde el primer día.
      </p>

      <div className="space-y-4 md:space-y-8" data-id="element-143">
        {tomos.map((tomo, i) => <div key={i} className="bg-zinc-900/80 rounded-2xl p-5 md:p-8 border border-zinc-800 hover:border-zinc-700 transition-all" data-id="element-144">
            <div className="flex items-start gap-4 md:gap-6" data-id="element-145">
              <div className={`text-4xl md:text-6xl shrink-0 bg-gradient-to-br ${tomo.color} bg-clip-text`} data-id="element-146">
                {tomo.emoji}
              </div>
              <div className="flex-1 min-w-0" data-id="element-147">
                <h3 className="text-xl md:text-3xl font-bold text-white mb-2 md:mb-3" data-id="element-148">
                  {tomo.title}
                </h3>
                <p className="text-sm md:text-lg text-zinc-400 mb-4 md:mb-6 italic" data-id="element-149">
                  {tomo.subtitle}
                </p>
                <ul className="space-y-2 md:space-y-3" data-id="element-150">
                  {tomo.items.map((item, j) => <li key={j} className="flex items-start gap-2 md:gap-3 text-sm md:text-base text-zinc-300" data-id="element-151">
                      <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-[#00b8ff] shrink-0 mt-0.5" data-id="element-152" />
                      <span data-id="element-153">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}